var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('infinite-loading',{staticClass:"col-12",attrs:{"identifier":_vm.infiniteIdentifier,"spinner":"spiral"},on:{"infinite":_vm.infiniteHandler}})}
var staticRenderFns = []

export { render, staticRenderFns }